import { BrowserRouter, Route, Routes } from "react-router-dom";
import PaginaBase from "./pages/HomePage";
import GlobalLocations from "./pages/GlobalLocations";
import Certificates from "./pages/Certificates";
import AboutUsPage from "./pages/AboutUs";
import PlasticCapabilitesPage from "./pages/PlasticCapabilitesPage";
import WirePage from "./pages/wireCapabilitiesPage";
import VideoPage from "./pages/Corporate";
import WireTestPage from "./pages/WireTestCapabilitiesPage";
import StampingPage from "./pages/StampingPage";
import StampingToolPage from "./pages/StampingToolPage";
import WeldingsPage from "./pages/WeldingsPage";
import EngineerPage from "./pages/EngineerPage";
import CapabilitesPage from "./pages/Capabilites";
import ProductPage from "./pages/ProductPage";
import MoldesCapabilitiesPage from "./pages/MoldesCapabilitiesPage";
import MultiComponentsPage from "./pages/MultiComponentsPage";
import EquipmentsPage from "./pages/EquipmentsPage";
import PrototypeFabricationPage from "./pages/PrototypeFabricationPage";
import ContactUsPage from "./pages/ContactUsPage";
import MetrologyCapabilitiesPage from "./pages/MetrologyPage";
import CustomersPage from "./pages/CustomersPage";
import ToolingAndManufacturingPage from "./pages/ToolingsPage";
import WireProductionPage from "./pages/WireProductionCapabilities";
import NewsPage from "./pages/NewsPage";

function AppRoutes() {
    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route path="/" element={<PaginaBase />} />
                <Route path="/AboutUs" element={<AboutUsPage />} />
                <Route path="/Capabilities" element={<CapabilitesPage />} />
                <Route path="/Capabilities/Engineering" element={<EngineerPage />} />
                <Route path="/Capabilities/Production" element={<ProductPage />} />
                <Route path="/GlobalLocations" element={<GlobalLocations />} />
                <Route path="/ContactUs" element={<ContactUsPage />} />
                <Route path="/Certificates" element={<Certificates />} />
                <Route path="/Capabilities/Production/Plastics" element={<PlasticCapabilitesPage />} />
                <Route path="/Capabilities/Production/Wires" element={<WirePage />} />
                <Route path="/Capabilities/Production/Equipments" element={<EquipmentsPage />} />
                <Route path="/Corporate" element={<VideoPage />} />
                <Route path="/corporate" element={<VideoPage />} />
                <Route path="/Capabilities/Production/WireChecks" element={<WireTestPage />} />
                <Route path="/Capabilities/Production/Stamping" element={<StampingPage />} />
                <Route path="/Capabilities/Engineering/StampingTool" element={<StampingToolPage />} />
                <Route path="/Capabilities/Production/Weldings" element={<WeldingsPage />} />
                <Route path="/Capabilities/Engineering/Molds" element={<MoldesCapabilitiesPage />} />
                <Route path="/Capabilities/Engineering/MultiComponetsCapabilities" element={<MultiComponentsPage />} />
                <Route path="/Capabilities/Engineering/PrototypeFabricationCapabilities" element={<PrototypeFabricationPage />} />
                <Route path="/Capabilities/Production/MetrologyCapabilities" element={<MetrologyCapabilitiesPage />} />
                <Route path="/Customers" element={<CustomersPage />} />
                <Route path="/Capabilities/ToolingAndManufacturing" element={<ToolingAndManufacturingPage />} />
                <Route path="/Capabilities/Production/WireProduction" element={<WireProductionPage />} />
                <Route path="/News" element={<NewsPage />} />

            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;
